const filtersActionConstants = {
  SET_CONTACT_FILTERS: 'SET_CONTACT_FILTERS',
  SET_DISPUTE_FILTERS: 'SET_DISPUTE_FILTERS',
  SET_FILTER_DROPDOWN_VALUES: 'SET_FILTER_DROPDOWN_VALUES',
};

export default filtersActionConstants;
